import { createReducer, on } from '@ngrx/store';
import * as UiActions from './ui.actions';
import { UiState, initialUiState } from './ui.state';
import {toggleReportSidebarTab} from "./ui.actions";

export const uiReducer = createReducer(
  initialUiState,
  on(UiActions.toggleReportSidebarTab, (state, { tabIndex, isClosing }) => {
    const isCurrentlyActive = state.reportSidebar.tabs[tabIndex].current;

    // If closing currently active tab
    if (isCurrentlyActive) {
      return {
        ...state,
        reportSidebar: {
          ...state.reportSidebar,
          activeTabIndex: null,
          isClosing: true,
          tabs: state.reportSidebar.tabs.map(tab => ({
            ...tab,
            current: false
          }))
        },
        aside: {
          ...state.aside,
          isOpen: false
        }
      };
    }

    // If activating a new tab
    return {
      ...state,
      reportSidebar: {
        ...state.reportSidebar,
        activeTabIndex: tabIndex,
        isClosing: false,
        tabs: state.reportSidebar.tabs.map((tab, index) => ({
          ...tab,
          current: index === tabIndex
        }))
      },
      aside: {
        ...state.aside,
        isOpen: true
      }
    };
  }),
  on(UiActions.initializeUiState, (state) => ({
    ...state,
    reportSidebar: {
      ...state.reportSidebar,
      activeTabIndex: 0,
      tabs: state.reportSidebar.tabs.map((tab, index) => ({
        ...tab,
        current: index === 0
      }))
    },
    aside: {
      ...state.aside,
      isOpen: true
    }
  })),
  on(UiActions.toggleAside, (state, { isOpen }) => ({
    ...state,
    aside: {
      ...state.aside,
      isOpen
    },
    reportSidebar: {
      ...state.reportSidebar,
      activeTabIndex: isOpen ? state.reportSidebar.activeTabIndex : null,
      tabs: state.reportSidebar.tabs.map(tab => ({
        ...tab,
        current: isOpen ? tab.current : false
      }))
    }
  })),
  on(UiActions.toggleDarkMode, (state, { isDarkMode }) => ({
    ...state,
    theme: {
      ...state.theme,
      isDarkMode
    }
  })),
  on(UiActions.toggleSubscriptionBanner, (state, { isVisible }) => ({
    ...state,
    banner: {
      ...state.banner,
      isSubscriptionVisible: isVisible
    }
  })),
  on(UiActions.toggleSidebarCollapsed, (state, { isCollapsed }) => ({
    ...state,
    sidebar: {
      ...state.sidebar,
      isCollapsed
    }
  }))
);
